import { useState } from "react";
import { FaTimes, FaEnvelope, FaUser, FaKey } from "react-icons/fa";
import { recoveryPasswordSchema } from "../../schemas/recovery-password";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm, Controller } from "react-hook-form";
import { authApi } from "../../api/auth.api";



function RecoveryPasswordModal({ open, onClose }) {
    const { register: register, watch, setValue, handleSubmit, control: control, formState: { errors: errors, isDirty: isDirty }, reset: reset } = useForm({
        resolver: zodResolver(recoveryPasswordSchema)
    })

    const [loading, setLoading] = useState(false);
    const [correctSend, setCorrectSend] = useState(false);
    
    const onSubmit = async (data) => {
        setLoading(true);
        try {
            await authApi.forgotPassword({ email: data.email });
            setCorrectSend(true);
        } catch (error) {
            setCorrectSend(true); // Always show success to prevent enumeration
        }
        finally {
            setLoading(false);
        }
    }
    return (
        <div className="modal-overlay">
            <div className="modal-box modal-content">
                <div className="modal-header-subtle">
                    <div>
                        <h2 className="modal-title">Recuperar Contraseña</h2>
                    </div>
                    <button className="modal-close-btn" onClick={onClose}>
                        <FaTimes />
                    </button>
                </div>
                <div className="main-div-form">
                    <div className="modal-body">
                        <div className="modal-icon-large">
                            <FaKey />
                        </div>
                    </div>
                    <form className="form-modal" onSubmit={handleSubmit(onSubmit)}>
                        <div className="div-atribute-form-w-full">
                            <p className="modal-note">
                                Introduce tu correo electrónico y te enviaremos instrucciones para restablecer tu contraseña.
                            </p>
                            <label className="label-atribute-form">
                                Correo electrónico<p className="span-asterisk">*</p>
                            </label>
                            <input
                                type="text"
                                maxLength={100}
                                {...register("email",
                                    {
                                        onChange: (e) => {
                                        },
                                    }
                                )}
                                placeholder="Correo electrónico"
                                className="input-atribute-form"
                            />
                            {errors.email && (
                                <span className="span-error-form">
                                    {errors.email.message}
                                </span>
                            )}
                        </div>
                        {correctSend && (
                            <div className="div-success">
                                ¡Si el correo esta asociado a una cuenta, recibirás instrucciones para restablecer tu contraseña ahora mismo!
                            </div>
                        )}
                        <div className="div-footer-form-actions">

                            <button
                                type="button"
                                onClick={onClose}
                                className="btn-cancel"
                            >
                                Cerrar
                            </button>

                            <button
                                type="submit"
                                disabled={(loading == true) ? true : false}
                                className="btn-primary"
                            >
                                {'Enviar'}
                            </button>

                        </div>
                    </form>
                </div>

            </div>
        </div>
    );
}

export default RecoveryPasswordModal;
